import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
export const BulletListWithoutInputRules = BulletList.extend({
    addInputRules() {
        return [];
    },
});
export const OrderedListWithoutInputRules = OrderedList.extend({
    addInputRules() {
        return [];
    },
});
//# sourceMappingURL=lists-without-input-rules.js.map